import _ from 'lodash';
import {
  AllegroCreateOrUpdateImpliedWarrantyRequest,
  AllegroImpliedWarrantyAddress,
  AllegroImpliedWarrantyPeriod,
} from '../../../../../api/allegro/impliedwarranty/impliedWarrantyTypes';
import { Edit } from './impliedWarrantyState';

function mapPeriod(value: string): AllegroImpliedWarrantyPeriod | undefined {
  return value ? { period: value } : undefined;
}

function mapAddress(edit: Edit): AllegroImpliedWarrantyAddress | undefined {
  const address = {
    name: edit.name,
    street: edit.street,
    postCode: edit.postCode,
    city: edit.city,
    countryCode: edit.countryCode || undefined,
  };

  if (_.every(address, _.isUndefined)) {
    return undefined;
  }

  return address as AllegroImpliedWarrantyAddress;
}

export default function mapRequest(edit: Edit): AllegroCreateOrUpdateImpliedWarrantyRequest {
  return {
    name: edit.label,
    individual: mapPeriod(edit.individualPeriod),
    corporate: mapPeriod(edit.corporatePeriod),
    address: mapAddress(edit),
    description: edit.description || undefined,
  };
}
